import React from 'react';

const exportedObject = () => {
  return (
  <div className="admin_footer">
  </div>
  );  
}

export default exportedObject